/* Filters. Progressieve verbetering: zonder dit bestand blijft alles werken —
   het formulier is een gewone GET met een zichtbare knop "Toon resultaten", en
   alle filteropties staan open. Dit script verstuurt meteen bij aanvinken en
   klapt lange lijsten in. */

(function () {
  'use strict';

  var TOON = 6; // aantal opties dat open blijft staan

  var teksten = window.ncStrings || {};
  var MEER = teksten.showMore || 'Toon meer';
  var MEER_TEKST = teksten.readMore || 'Lees meer';
  var MINDER_TEKST = teksten.readLess || 'Lees minder';
  var MINDER = teksten.showLess || 'Toon minder';

  /* Filteren zonder de pagina opnieuw te laden.

     Eerst deed een vinkje form.submit(). Dat werkt, maar het is een volledige
     paginalading: je springt naar boven, de zijbalk klapt weer dicht en je
     bent kwijt waar je was. Bij het derde filter op rij is dat vermoeiend.

     Nu wordt alleen de collectiesectie opnieuw opgehaald met de Section
     Rendering API en op zijn plek gezet. De URL gaat mee via pushState, dus
     delen en de terugknop blijven werken. Zonder JavaScript verstuurt het
     formulier gewoon zoals het altijd deed. */

  function sectieVan(el) {
    return el.closest('[id^="shopify-section-"]');
  }

  /* Wat een filter werkelijk verandert: de balk met de actieve chips en de
     telling, de zijbalk met de aantallen per optie, en het raster zelf. De
     kruimels, de kop met de omschrijving en de rij subcategorieën staan er
     buiten — die zijn voor elk filter gelijk.

     Alleen deze drie vervangen is geen besparing maar een reparatie. De sectie
     begint met haar eigen <link rel="stylesheet">. Verving je de hele sectie,
     dan ging die link mee: eerst weg, dan opnieuw erin. In de tel-momenten
     daartussen gold de inklap-CSS niet, en precies daar mat het script hoe
     hoog de omschrijving is. Ingeklapt en uitgeklapt waren dan even hoog, het
     script concludeerde "inkorten is hier niet nodig" en haalde de inkorting
     weg. Eén klik op een filter en de hele lap tekst stond open, zonder knop
     om hem weer dicht te doen. */
  var DELEN = ['.col__typechips', '.col__balk', '.col__zijbalk', '.col__resultaten'];

  function wisselen(sectie, bron) {
    var gewisseld = 0;
    var scheef = 0;

    DELEN.forEach(function (kies) {
      var oud = sectie.querySelector(kies);
      var nieuw = bron.querySelector(kies);
      if (oud && nieuw) {
        oud.replaceWith(nieuw);
        gewisseld++;
      } else if (oud || nieuw) {
        // Aan één kant wel en aan de andere niet: de opbouw wijkt af.
        scheef++;
      }
    });

    // Wijkt de opbouw af, dan alsnog alles vervangen. Liever de omschrijving
    // opnieuw opbouwen dan een pagina die niet bijwerkt.
    if (gewisseld === 0 || scheef > 0) sectie.innerHTML = bron.innerHTML;
  }

  function schoneVraag(form) {
    var uit = new URLSearchParams();
    new FormData(form).forEach(function (waarde, naam) {
      // Lege prijsvelden hoeven niet mee: die leverden een URL op met
      // filter.v.price.gte=&filter.v.price.lte= zonder dat er iets gefilterd is.
      if (String(waarde).trim() !== '') uit.append(naam, waarde);
    });
    return uit;
  }

  var bezig = false;

  function ophalen(form, url) {
    var sectie = sectieVan(form);
    if (!sectie || bezig) return false;
    var id = sectie.id.replace('shopify-section-', '');

    bezig = true;
    sectie.setAttribute('aria-busy', 'true');
    sectie.classList.add('is-bezig');

    var scheiding = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + scheiding + 'sections=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data[id]) throw new Error('geen sectie terug');
        var nieuw = new DOMParser().parseFromString(data[id], 'text/html');
        var bron = nieuw.querySelector('[id="shopify-section-' + id + '"]') || nieuw.body.firstElementChild;
        if (!bron) throw new Error('leeg antwoord');
        wisselen(sectie, bron);
        init(sectie);
      })
      .catch(function () { window.location.href = url; })
      .then(function () {
        bezig = false;
        sectie.removeAttribute('aria-busy');
        sectie.classList.remove('is-bezig');
      });

    return true;
  }

  function versturen(form) {
    var vraag = schoneVraag(form).toString();
    var url = form.getAttribute('action') + (vraag ? '?' + vraag : '');
    if (ophalen(form, url)) {
      window.history.pushState({ facet: true }, '', url);
    }
  }

  function directVersturen(wortel) {
    wortel.querySelectorAll('form[data-facet-form]').forEach(function (form) {
      if (form.dataset.klaar === 'ja') return;
      form.dataset.klaar = 'ja';

      var knop = form.querySelector('[data-facet-submit]');
      if (knop) knop.hidden = true;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        versturen(form);
      });

      form.querySelectorAll('[data-facet-auto]').forEach(function (veld) {
        veld.addEventListener('change', function () { versturen(form); });
      });
    });
  }

  /* Terug- en vooruitknop: dezelfde sectie opnieuw ophalen voor de URL waar de
     browser nu op staat. */
  window.addEventListener('popstate', function () {
    var form = document.querySelector('form[data-facet-form]');
    if (form) ophalen(form, window.location.pathname + window.location.search);
  });

  function inklappen(wortel) {
    wortel.querySelectorAll('[data-facet-group]').forEach(function (groep) {
      if (groep.dataset.ingeklapt === 'ja') return;
      var opties = [].slice.call(groep.querySelectorAll('[data-facet-option]'));
      if (opties.length <= TOON + 1) return;

      // Een aangevinkte optie moet zichtbaar blijven, ook als hij verderop staat.
      var extra = opties.slice(TOON);
      var heeftActief = extra.some(function (o) {
        var v = o.querySelector('input');
        return v && v.checked;
      });
      if (heeftActief) return;

      extra.forEach(function (o) { o.hidden = true; });

      var knop = document.createElement('button');
      knop.type = 'button';
      knop.setAttribute('aria-expanded', 'false');
      knop.style.cssText =
        'align-self:flex-start;padding:2px 0;border:0;background:none;font-family:inherit;' +
        'font-size:12px;color:#2B2B2B;text-decoration:underline;text-underline-offset:3px;cursor:pointer';
      knop.textContent = MEER + ' (' + extra.length + ')';

      knop.addEventListener('click', function () {
        var open = knop.getAttribute('aria-expanded') === 'true';
        extra.forEach(function (o) { o.hidden = open; });
        knop.setAttribute('aria-expanded', open ? 'false' : 'true');
        knop.textContent = open ? MEER + ' (' + extra.length + ')' : MINDER;
      });

      groep.appendChild(knop);
      groep.dataset.ingeklapt = 'ja';
    });
  }

  /* Past de tekst in het aantal regels dat de sectie-instelling toestaat?

     Eerst werd dat gemeten door in te klappen en te kijken of de tekst korter
     werd. Dat leest logisch, maar het antwoord hing af van CSS die op dat
     moment geladen moest zijn. Was zij dat niet, dan waren beide metingen
     gelijk, luidde het antwoord "past prima" en bleef de hele omschrijving
     openstaan zonder knop.

     Deze meting kijkt niet naar het verschil maar naar de hoogte zelf:
     scrollHeight is de volle hoogte van de inhoud, ingeklapt of niet. Het
     antwoord is daarmee in beide toestanden hetzelfde. --regels staat als
     stijlattribuut op het element zelf en de regelhoogte erft van theme.css,
     dus geen van beide wacht op de sectie-CSS. */
  function moetInkorten(inhoud) {
    var stijl = getComputedStyle(inhoud);
    var regels = parseInt(stijl.getPropertyValue('--regels'), 10) || 3;
    var regelhoogte = parseFloat(stijl.lineHeight);
    if (!regelhoogte) regelhoogte = (parseFloat(stijl.fontSize) || 15) * 1.65;
    return inhoud.scrollHeight > regelhoogte * regels + 8;
  }

  function tekstInklappen(wortel) {
    wortel.querySelectorAll('[data-collectietekst]').forEach(function (wrap) {
      if (wrap.dataset.klaar === 'ja') return;
      var inhoud = wrap.querySelector('[data-collectietekst-inhoud]');
      if (!inhoud) return;
      wrap.dataset.klaar = 'ja';

      // Past het, dan geen inkorting en geen knop die niets te doen heeft.
      if (!moetInkorten(inhoud)) return;
      inhoud.classList.add('is-ingeklapt');

      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'collectietekst__knop';
      knop.setAttribute('aria-expanded', 'false');
      knop.textContent = MEER_TEKST;
      knop.addEventListener('click', function () {
        var staatOpen = knop.getAttribute('aria-expanded') === 'true';
        inhoud.classList.toggle('is-ingeklapt', staatOpen);
        knop.setAttribute('aria-expanded', staatOpen ? 'false' : 'true');
        knop.textContent = staatOpen ? MEER_TEKST : MINDER_TEKST;
      });
      wrap.appendChild(knop);
    });
  }

  /* Filterknop voor 390px. Bewust in JavaScript en niet in Liquid: zonder dit
     script staat de zijbalk gewoon open en zou een knop die niets doet alleen
     maar in de weg zitten. */
  var SMAL = window.matchMedia('(max-width: 989px)');

  /* Buiten de functie, want de balk en de zijbalk worden bij elk filter
     vervangen en daarmee ook de knop. Stond dit binnenin, dan klapte het
     paneel op een telefoon bij elk vinkje weer dicht en moest je het voor het
     tweede filter opnieuw openen. */
  var filtersOpen = false;

  function filterknop(wortel) {
    wortel.querySelectorAll('[data-filterknop-plek]').forEach(function (plek) {
      if (plek.dataset.klaar === 'ja') return;
      var paneel = document.querySelector('[data-filterpaneel]');
      if (!paneel) return;
      plek.dataset.klaar = 'ja';

      var aantal = parseInt(plek.dataset.actief, 10) || 0;
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'col__filterknop';
      knop.setAttribute('aria-expanded', filtersOpen ? 'true' : 'false');
      knop.innerHTML =
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
        '<path d="M3 6h18M6 12h12M10 18h4"></path></svg>';
      knop.appendChild(document.createTextNode(
        (teksten.filter || 'Filter') + (aantal > 0 ? ' (' + aantal + ')' : '')
      ));

      function stemAf() {
        if (SMAL.matches) {
          paneel.hidden = knop.getAttribute('aria-expanded') !== 'true';
        } else {
          paneel.hidden = false;
        }
      }

      knop.addEventListener('click', function () {
        filtersOpen = knop.getAttribute('aria-expanded') !== 'true';
        knop.setAttribute('aria-expanded', filtersOpen ? 'true' : 'false');
        stemAf();
      });

      plek.appendChild(knop);
      stemAf();
      SMAL.addEventListener('change', stemAf);
    });
  }

  function init(wortel) {
    directVersturen(wortel);
    inklappen(wortel);
    tekstInklappen(wortel);
    filterknop(wortel);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
